<template>
  <div class="jineng">
    <div class="title animate__animated wow animate__fadeInUp">
      <titleCard title="National Hemodialysis Standardization Competition"></titleCard>
    </div>
    <div class="jianjie animate__animated wow animate__fadeInUp">
      <h4>Introduction </h4>
      <p class="p1">
        The first "National Standardized Hemodialysis Operation Skills Competition", hosted by the Capacity Building and Continuing Education Center of the NHC, is to further standardize the clinical hemodialysis operation, improve the competence of relevant professionals and personnel, strengthen the construction and continuing education of the hemodialysis medical team in medical institutions and community health service centers at provincial, municipal and county levels, drive the process of chronic disease management at grassroots level, and better serve patients. <br>
      </p>
      <p class="p2">
        The first "National Standardized Hemodialysis Operation Skills Competition", hosted by the Capacity Building and Continuing Education Center of the NHC, is to further standardize the clinical hemodialysis operation, improve the competence of relevant professionals and personnel, strengthen the construction and continuing education of the hemodialysis medical team in medical institutions and community health service centers at provincial, municipal and county levels, drive the process of chronic disease management at grassroots level, and better serve patients. 
      </p>
    </div>
    <div class="ruko"></div>
    <div  class="ruko2 animate__animated wow animate__pulse"><span><a
          href="http://www.gyycbj.com/jnds/index.html#/Home" target="_blank">Competition</a></span></div>
    <footerCard name="Mr Zou" phone="181-8084-6771"></footerCard>
  </div>
</template>

<script>
import titleCard from '../../components/title-card.vue'
import footerCard from '../../components/footer-card.vue'
export default {
  data() {
    return {

    }
  },
  created() {

  },
  components: {
    titleCard,
    footerCard
  },
  mounted() {

  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.jineng {
  .title {
    padding: 1rem 0;
  }
  .jianjie {
    height: 3.8316rem;
    width: 100%;
    text-align: center;
    background: url('../../assets/image/Science/jineng/jineng1.webp') no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 540px) {
      height: 450px;
      background-size: cover;
    }
    h4 {
      color: #334046;
      font-size: 0.3368rem;
      padding: 0.4684rem 0;
      margin: 0;
      @media screen and (max-width: 540px) {
        font-size: 17px;
        padding: 36px 0 20px 0;
      }
    }
    p {
      color: #272b2d;
      font-size: 0.2526rem;
      line-height: 0.4211rem;
      @media screen and (max-width: 540px) {
        font-size: 15px;
        line-height: 26px;
        padding: 0 25px;
      }
    }
    .p1 {
      padding: 0 2rem;
      @media screen and (max-width: 540px) {
        display: none;
      }
    }
    .p2 {
      display: none;
      @media screen and (max-width: 540px) {
        display: block;
      }
    }
  }
  .ruko {
    width: 11.9368rem;
    height: 7.6421rem;
    background: url('../../assets/image/Science/jineng/jineng.png') no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    margin-top: 1.1368rem;
    margin-bottom: 1.3053rem;
    @media screen and (max-width: 540px) {
      margin: 0;
      width: 100%;
      height: 270px;
    }
  }
  .ruko2 {
    @media screen and (max-width: 540px) {
      height: 37px;
      line-height: 37px;
      width: 100%;
      background-size: 140% 100%;
      font-size: 12px;
      background-position: 52% 0;
    }
    width: 16.6316rem;
    height: 0.7895rem;
    line-height: 0.7895rem;
    background: url('../../assets/image/Science/zhuanxiang/zhuanxiang4.webp')
      no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    margin-bottom: 1.6842rem;
    text-align: center;
    a {
      cursor: pointer;
      font-size: 0.2947rem;
      color: #ffffff;
      span {
        cursor: pointer;
      }
    }
  }
}
</style>
